import "./App.css";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./firebase";
import { useUser } from "./context/UserContext";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { updateFirebaseToken } from "./api/users/users";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";

const App = () => {
  const { user } = useUser();


  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope,
          );
        })
        .catch((error) => {
          console.error("Service worker registration failed:", error);
        });
    }
  }, []);

  useEffect(() => {
    if (user) {
      askForNotificationsPermission();
    }
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
      toast("Έχετε νέα ειδοποίηση για ομιλία");
      // Customize notification here
    });
  }, []);

  const askForNotificationsPermission = async () => {
    try {
      if (Notification.permission !== "granted") {
        toast("Ενεργοποιήστε τις ειδοποιήσεις για να λαμβάνετε ενημερώσεις", {
          autoClose: false,
        });
        await Notification.requestPermission();
      }

      if (Notification.permission === "granted" && user) {
        const token = await getToken(messaging, {
          vapidKey:
            "BJ2xsnDqCULYPPaCgnqnGLwstHqJf4PjeYUGxjQGxndUBtDNGvfZw7V1eI20VYLO83z-8jiyEkrLXC5iwv6lT6k",
        });
        console.log("FCM registration token:", token);
        if (user?.firebaseToken !== token) {
          const res = await updateFirebaseToken(user?.uid, token);
          if (!res) {
            toast.error("Failed to update token. Please try again.", {
              autoClose: 500,
              position: "bottom-center",
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return <RouterProvider router={router} />;
};

export default App;
